import React, { useContext, useEffect } from 'react';
import { RoomContext } from '../context/RoomContext';
import { TbGhostFilled } from 'react-icons/tb';

function MessageItem({ message }) {
  const { content, whisper, from } = message;
  const { roomInfo, setRoomInfo } = useContext(RoomContext);
  useEffect(() => {
    setRoomInfo({ ...roomInfo, nickname: '나' });
  }, []);
  return (
    <>
      {content !== undefined && (
        <div className="">
          {/* =======상대방======= */}
          {roomInfo.nickname === from ? (
            <div className="flex w-full mt-2 space-x-3 max-w-xs ml-auto justify-end">
              <div>
                <div className="bg-blue-600 text-white p-3 rounded-l-lg rounded-br-lg">
                  <p className="text-sm">{content}</p>
                </div>
              </div>
              <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-300"></div>
            </div>
          ) : (
            <div className="flex w-full mt-2 space-x-3 max-w-xs">
              <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-300"></div>
              <div>
                <span>
                  {from}{' '}
                  {whisper && (
                    <>
                      님의 귓속말 <TbGhostFilled></TbGhostFilled>
                    </>
                  )}
                </span>
                <div className="bg-gray-300 p-3 rounded-r-lg rounded-bl-lg">
                  <p className="text-sm text-black">{content}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default React.memo(MessageItem);
